const getInviteList = async (service) => {
  const users = await service.get(`/org/invitation/list`);
  return users;
};



const inviteUser = async (service, user, groupId) => {
  // user coming from the UI already has orgPays mapped; strip out any UI-only fields
  const { payment_responsibility, ...rest } = user || {};
  const payload = groupId ? { ...rest, groupId } : { ...rest };

  // Debug: log the exact request body being sent to the backend
  // eslint-disable-next-line no-console
  console.log("Inviting org user with payload:", payload);

  return service.post("/org/invitation", payload);
};

const resendInvite = async (service, linkId) => {
  return service.put("/org/invitation", { magicLinkId: linkId });
};

export { getInviteList, inviteUser, resendInvite };
